import { render, staticRenderFns } from "./previous.vue?vue&type=template&id=1200b203&scoped=true"
import script from "./previous.vue?vue&type=script&lang=js"
export * from "./previous.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/project.css?vue&type=style&index=0&id=1200b203&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1200b203",
  null
  
)

export default component.exports